import React from "react";
												   
																					 
import { Link } from "react-router-dom";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";


import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import "swiper/css/pagination";

// sliderData.js
// Used by LatestNews, PartnerUpdates, SaudiaCompetitions, PartnerStreams, etc.

import slide_image_1 from "../../assets/images/slider/slider1.jpg";
import slide_image_2 from "../../assets/images/slider/slider2.jpg";
import slide_image_3 from "../../assets/images/slider/slider3.jpg";
import Example from "./Example";


const slides = [
  {
    id: 1,
    title: "Header",
    description:
      "Lorem ipsum dolor sit amet consectetur. Id pulvinar amet tempor elit felis sed odio eget. Et sit amet diam lectus donec integer nisl velit.",
    img: "https://c4.wallpaperflare.com/wallpaper/142/751/831/landscape-anime-digital-art-fantasy-art-wallpaper-preview.jpg"
  },
  {
    id: 2,
    title: "Header",
    description:
      "Lorem ipsum dolor sit amet consectetur. Id pulvinar amet tempor elit felis sed odio eget. Et sit amet diam lectus donec integer nisl velit.",
    img: null
  },
  {
    id: 3,
    title: "Header",
    description:
      "Lorem ipsum dolor sit amet consectetur. Id pulvinar amet tempor elit felis sed odio eget. Et sit amet diam lectus donec integer nisl velit.",
    img: null
  },
  {
    id: 4,
    title: "Header",
    description:
      "Lorem ipsum dolor sit amet consectetur. Id pulvinar amet tempor elit felis sed odio eget. Et sit amet diam lectus donec integer nisl velit.",
    img: null
  }
];

function GamesQuiz() {
  
  return (
    <>
      <Example/>
    </>
  );
}

export default GamesQuiz;
